import angular from 'angular';
import template from './template.html'
import './style.scss';
import BaseComponent from '../../base/component';
import Logger from '../../../shared/logger';

export class PositionCalibrationStatusLabel extends BaseComponent {

    isLabelVisible = true;
    isLabelLinkDisabled;
    isWizardStarted = true;
    currentStepName;
    currentStepLink;
    currentStepTitle;
    positionService;
    isLoading;

    JobWizardSteps = {
        create: 'create',
        edit: 'edit',
        samples: 'samples',
        tips: 'tips',
        preliminaryFeedback: 'preliminaryFeedback',
        completeMessage: 'completeMessage',
    };

    /* @ngInject */
    constructor($scope, EnvSettings, PositionService, RecruiterService) {
        super();
        this.positionService = PositionService;
        this.envSettings = EnvSettings;
        this.recruiterService = RecruiterService;
        this.$scope = $scope;
    }

    $onInit() {
        this.setupValues();
    }

    $onChanges() {
        this.setupValues();
    }

    async setupValues() {
        if (this.employerId && this.positionId) {
            try {
                this.isLoading = true;
                const result = await this.positionService.getUploadJobWizardStep(this.positionId, { isSkipStepValidation: true });
                const {feedbackFlowData: { isFeedbackRequested }, currentStepName, stepName: nextStepName} = result;
                this.currentStepName = currentStepName;
                this.isLabelLinkDisabled = this.getLabelLinkState({isFeedbackRequested, currentStepName});
                this.currentStepTitle = this.getDisplayStepName({currentStepName, isFeedbackRequested});
                this.currentStepLink = `${this.envSettings.WebAppUrl}/employer/${this.employerId}/position/${this.positionId}/wizard/${nextStepName}`;
            } catch (err) {
                this.isLabelVisible = false;
                Logger.error(`Upload job wizard current step not found for positionId: ${this.positionId}`);
            } finally {
                this.isLoading = false;
                this.$scope.$apply();
            }
        }
    }

    getDisplayStepName({isFeedbackRequested, currentStepName}) {
        if (isFeedbackRequested) {
            return 'JOB_VIEW_CALIBRATION_STATUS_ACHIEVED';
        }

        switch (currentStepName) {
            case this.JobWizardSteps.create:
                return 'JOB_VIEW_CALIBRATION_STATUS_DEFINITION';
            case this.JobWizardSteps.edit:
                return 'JOB_VIEW_CALIBRATION_STATUS_EXAMPLE';
            case this.JobWizardSteps.samples:
            case this.JobWizardSteps.tips:
            case this.JobWizardSteps.preliminaryFeedback:
                return 'JOB_VIEW_CALIBRATION_STATUS_PRELIMINARY_FEEDBACK';
            case this.JobWizardSteps.completeMessage:
                return 'JOB_VIEW_CALIBRATION_STATUS_DONE';
            default:
                this.isWizardStarted = false;
                return 'JOB_VIEW_CALIBRATION_STATUS_NOT_STARTED';
        }
    }

    getLabelLinkState({isFeedbackRequested, currentStepName}) {
        const isUploadWizardCompleted = currentStepName === this.JobWizardSteps.completeMessage;
        return isFeedbackRequested || isUploadWizardCompleted;
    }

    async onLinkClick(event) {
        if (!this.isWizardStarted && this.positionId) {
            try {
                const {result: talenyaBot} = await this.recruiterService.getTalenyaBotRecruiter();
                await this.positionService.addRecruiterToPosition({
                    positionId: this.positionId,
                    recruiterId: talenyaBot._id
                });
            } catch (err) {
                event.preventDefault();
                event.stopPropagation();
                Logger.error(`Failed to add Talenya Bot to position: ${this.positionId}, ${err}`);

            }
        }
    }
}

export const config = {
    template,
    bindings: {
        positionId: '<',
        employerId: '<',
    },
    controller: PositionCalibrationStatusLabel,
    controllerAs: 'positionCalibrationStatusLabelCtrl',
};

angular.module('TALENYA-FE').component('positionCalibrationStatusLabel', config);